// Disclaimer: We love lodash <3, but we are using just a small amount of helpers functions
// that it doesn't seems relevante to include the whole library here for this purpose.

// It's also possible to include only the modularized versions of lodash as dependency:
// https://www.npmjs.com/search?q=keywords%3Alodash-modularized%20isString

// But this also seems too much, so we are just grabing out the functions(and its tests) which
// we use on this library and putting it all together here in this file.

// All credits to this code should be given to "lodash" and its open source contributors
// which can be found at: `https://github.com/lodash/lodash/`

// From: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
export const getTag = (value) => {
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]'
  }

  return Object.prototype.toString.call(value)
}

// From: https://github.com/lodash/lodash/blob/master/isObjectLike.js
export const isObjectLike = (value) => typeof value === 'object' && value !== null // prettier-ignore

// eslint-disable-next-line arrow-body-style
export const isBoolean = (value) => {
  return (
    value === true ||
    value === false ||
    (isObjectLike(value) && getTag(value) === '[object Boolean]')
  )
}

// From: https://github.com/lodash/lodash/blob/master/isString.js
export const isString = (value) => {
  const type = typeof value
  return (
    type === 'string' ||
    (type === 'object' &&
      value != null &&
      !Array.isArray(value) &&
      getTag(value) === '[object String]')
  )
}

// eslint-disable-next-line arrow-body-style
export const isNumber = (value) => {
  return (
    typeof value === 'number' ||
    (isObjectLike(value) && getTag(value) === '[object Number]')
  )
}

// https://github.com/lodash/lodash/blob/master/isNull.js
export const isNull = (value) => value === null
